export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'd56d0199-829c-4ced-a2f6-792b6d1f006e';
export const MODAL_CLOSE_SEC = 1;
